export const siteMeta = {
  name: "黑料导航",
  tagline: "吃瓜资讯聚合 · 地址发布",
  statusText: "线路运行正常",
  updatedAt: "2026-09-11 09:20",
  intro:
    "一个专注吃瓜资讯聚合的导航站，实时同步站点最新更新与维护动态，遇到失效会及时告知换地址与新网址，持续提供可用入口，帮你避免吃瓜迷路。",
};

export const heroStats = [
  { label: "收录入口", value: "12", unit: "条" },
  { label: "今日更新", value: "3", unit: "条" },
  { label: "稳定运行", value: "1080", unit: "天" },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Moody%20abstract%20artistic%20backdrop%20in%20deep%20crimson%20and%20burnt%20amber%20tones%20with%20subtle%20paper%20grain%20texture%20and%20soft%20diagonal%20light%20streaks%2C%20editorial%20minimal%20poster%20style%2C%20large%20dark%20areas%20left%20open%20for%20text%20contrast%2C%20no%20text%20no%20people&width=1600&height=900&seq=heiliao-hero-bg-01&orientation=landscape";

export const tickerItems = [
  "线路 A 已更换新域名，请以本页公示地址为准",
  "9 月 10 日服务器维护已完成，加载速度恢复",
  "新增备用入口 C，手机端体验进一步优化",
  "官方提醒：警惕仿冒站点，谨防私下收费",
];

export const updates = [
  {
    date: "09-11",
    time: "09:20",
    tag: "换地址",
    title: "线路 A 域名变更完成，旧地址停止服务",
    desc: "为提升稳定性，主线路已完成新域名切换。请从本页重新获取入口，旧地址后续将无法打开。",
  },
  {
    date: "09-10",
    time: "18:05",
    tag: "维护",
    title: "服务器例行维护结束，页面加载恢复正常",
    desc: "本次维护主要优化了图片加载与首屏速度，移动端打开速度平均提升约四成。",
  },
  {
    date: "09-09",
    time: "11:40",
    tag: "新入口",
    title: "新增备用线路 C，面向手机端单独优化",
    desc: "线路 C 针对移动网络做了节流处理，弱网环境下也能稳定进入，建议手机用户收藏。",
  },
  {
    date: "09-07",
    time: "21:12",
    tag: "线路",
    title: "部分区域访问波动，已切换至新 CDN 节点",
    desc: "受运营商线路调整影响，个别地区出现短暂卡顿，目前已完成节点切换并恢复。",
  },
  {
    date: "09-05",
    time: "10:00",
    tag: "安全",
    title: "官方公告：请勿相信任何以本站名义收费的渠道",
    desc: "本站入口永久免费。若遇到索要费用的第三方页面，请立即关闭，并回到本页核对正确地址。",
  },
];

export const entryLines = [
  {
    code: "A",
    name: "主线路 · 极速入口",
    desc: "官方主入口，加载最快，日常浏览推荐优先使用。",
    status: "available",
    region: "全地区",
    latency: "低延迟",
  },
  {
    code: "B",
    name: "备用线路 · 稳定优先",
    desc: "当主线路拥堵或打不开时切换，稳定性更好。",
    status: "available",
    region: "全地区",
    latency: "中延迟",
  },
  {
    code: "C",
    name: "移动线路 · 手机专享",
    desc: "为手机端单独优化，省流量、弱网也能稳定进入。",
    status: "available",
    region: "移动网络",
    latency: "低延迟",
  },
  {
    code: "D",
    name: "海外线路 · 面向境外",
    desc: "面向海外访问，延迟更低；目前正在升级维护中。",
    status: "maintenance",
    region: "海外",
    latency: "维护中",
  },
];

export const trendingTopics = [
  {
    rank: "01",
    title: "综艺新一期话题合集",
    summary: "节目播出后讨论量快速上涨，整理了本期几个被反复提到的名场面。",
    heat: "热度 98.6 万",
    tag: "综艺",
    image:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20editorial%20thumbnail%20with%20soft%20crimson%20and%20amber%20gradient%2C%20subtle%20grain%20texture%2C%20single%20minimal%20circle%20motif%2C%20clean%20simple%20background%2C%20no%20text&width=240&height=240&seq=heiliao-topic-01&orientation=squarish",
  },
  {
    rank: "02",
    title: "新剧口碑两极化观察",
    summary: "同一部剧的评价在两个方向来回拉扯，观众关注点集中在哪几处？",
    heat: "热度 87.2 万",
    tag: "影视",
    image:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20editorial%20thumbnail%20with%20soft%20crimson%20and%20amber%20gradient%2C%20subtle%20grain%20texture%2C%20minimal%20diagonal%20stripes%20motif%2C%20clean%20simple%20background%2C%20no%20text&width=240&height=240&seq=heiliao-topic-02&orientation=squarish",
  },
  {
    rank: "03",
    title: "游戏版本更新玩家反馈",
    summary: "新版本上线首日，玩家讨论最多的改动点与体验变化汇总。",
    heat: "热度 76.4 万",
    tag: "游戏",
    image:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20editorial%20thumbnail%20with%20soft%20crimson%20and%20amber%20gradient%2C%20subtle%20grain%20texture%2C%20minimal%20rounded%20square%20motif%2C%20clean%20simple%20background%2C%20no%20text&width=240&height=240&seq=heiliao-topic-03&orientation=squarish",
  },
  {
    rank: "04",
    title: "赛事赛后热评整理",
    summary: "关键判罚与临场调整引发集中讨论，核心观点为你梳理成短摘要。",
    heat: "热度 69.8 万",
    tag: "体育",
    image:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20editorial%20thumbnail%20with%20soft%20crimson%20and%20amber%20gradient%2C%20subtle%20grain%20texture%2C%20minimal%20horizontal%20line%20motif%2C%20clean%20simple%20background%2C%20no%20text&width=240&height=240&seq=heiliao-topic-04&orientation=squarish",
  },
  {
    rank: "05",
    title: "网络热梗出处考据",
    summary: "最近刷屏的那个梗到底从哪来？顺着时间线帮你找到最早的出处。",
    heat: "热度 58.3 万",
    tag: "玩梗",
    image:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20editorial%20thumbnail%20with%20soft%20crimson%20and%20amber%20gradient%2C%20subtle%20grain%20texture%2C%20minimal%20triangle%20motif%2C%20clean%20simple%20background%2C%20no%20text&width=240&height=240&seq=heiliao-topic-05&orientation=squarish",
  },
  {
    rank: "06",
    title: "科技发布会讨论汇总",
    summary: "新品发布后大家最关心的几个问题，以及来自评论区的高频追问。",
    heat: "热度 51.7 万",
    tag: "科技",
    image:
      "https://readdy.ai/api/search-image?query=Warm-toned%20abstract%20editorial%20thumbnail%20with%20soft%20crimson%20and%20amber%20gradient%2C%20subtle%20grain%20texture%2C%20minimal%20dot%20cluster%20motif%2C%20clean%20simple%20background%2C%20no%20text&width=240&height=240&seq=heiliao-topic-06&orientation=squarish",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "收藏本页地址",
    desc: "把本站主页加入书签，地址一旦变更，本页会第一时间同步。",
  },
  {
    step: "02",
    title: "优先走主线路",
    desc: "日常浏览先点线路 A；若打不开或加载慢，再依次尝试其他线路。",
  },
  {
    step: "03",
    title: "看更新动态再进",
    desc: "进站前扫一眼更新板块，若提示换地址，用最新公示地址重新进入。",
  },
  {
    step: "04",
    title: "遇到异常先回本页",
    desc: "页面打不开多半是线路调整，回到本页重新获取入口即可，不必着急。",
  },
];

export const safetyPoints = [
  {
    icon: "ri-shield-check-line",
    title: "认准本站公示地址",
    desc: "所有可用入口都以本页为准，其他来源的地址请一律不要相信。",
  },
  {
    icon: "ri-money-cny-circle-line",
    title: "任何收费都是假的",
    desc: "本站入口永久免费，凡是以本站名义索要费用的页面都是仿冒站。",
  },
  {
    icon: "ri-user-unfollow-line",
    title: "不轻信私信与私聊",
    desc: "没有所谓内部渠道或特殊入口，避免点击陌生人发来的短链接。",
  },
];

export const faqs = [
  {
    q: "为什么原来的地址突然打不开了？",
    a: "多半是线路调整或域名更换。本站不发通知邮件，只会在本页的「最新更新」板块公示新地址，遇到打不开时回到本页重新获取入口即可。",
  },
  {
    q: "如何判断我现在用的地址是不是最新的？",
    a: "本页顶部会显示最近一次更新时间和当前状态。如果你用的地址与页面公示的不一致，说明已经过期，请以本页公示为准。",
  },
  {
    q: "线路 A 打不开，应该先试哪一个？",
    a: "建议先切到备用线路 B；手机端优先尝试线路 C。海外用户可以等线路 D 维护结束后使用，或先选备用线路。",
  },
  {
    q: "本站需要注册或付费吗？",
    a: "不需要。浏览本站入口无需注册账号，也没有任何付费项目，凡是要求注册、付费、加群的渠道都不是官方渠道。",
  },
  {
    q: "更新动态多久同步一次？",
    a: "只要有换地址、维护或线路调整，都会尽量在当天同步到本页，并在顶部标注更新时间，方便你确认信息新鲜度。",
  },
  {
    q: "收藏页面后，换地址了还能找到吗？",
    a: "可以。建议收藏本页而不是直接收藏具体线路地址，本页地址保持稳定，线路怎么换都能从这里重新进入。",
  },
];

export const communityPosts = [
  {
    name: "吃瓜不迷路",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20avatar%20of%20a%20friendly%20person%20in%20warm%20crimson%20and%20amber%20palette%2C%20simple%20solid%20plain%20background%2C%20clean%20editorial%20style%2C%20no%20text&width=128&height=128&seq=heiliao-avatar-01&orientation=squarish",
    time: "今天 09:32",
    content: "线路 A 换地址后速度快了不少，手机端也顺滑，给维护的同学点个赞。",
    likes: 128,
  },
  {
    name: "深夜刷榜人",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20avatar%20of%20a%20calm%20person%20in%20warm%20amber%20and%20stone%20palette%2C%20simple%20solid%20plain%20background%2C%20clean%20editorial%20style%2C%20no%20text&width=128&height=128&seq=heiliao-avatar-02&orientation=squarish",
    time: "今天 08:47",
    content: "建议把线路 C 放到更前面，地铁上刷的时候真的很稳。",
    likes: 86,
  },
  {
    name: "路过的老用户",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20avatar%20of%20a%20cheerful%20person%20in%20warm%20crimson%20and%20sand%20palette%2C%20simple%20solid%20plain%20background%2C%20clean%20editorial%20style%2C%20no%20text&width=128&height=128&seq=heiliao-avatar-03&orientation=squarish",
    time: "昨天 22:15",
    content: "差点进了仿冒站，还好先回本页对了一下地址，大家真的别乱点私信链接。",
    likes: 214,
  },
];

export const navLinks = [
  { label: "更新动态", href: "#updates" },
  { label: "可用入口", href: "#entries" },
  { label: "今日热榜", href: "#trending" },
  { label: "使用指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];